import React from 'react';
import { ArrowUpRight, BookOpen, PenLine } from 'lucide-react';

import './Writing.css';
import { theme } from '../../theme/designSystem';
import { writingData } from '../../data/writingData';

const featured = writingData.find((p) => p.featured) || writingData[0];
const rest = writingData.filter((p) => p.id !== featured.id);

function Writing() {
    return (
        <section className="writing section-pad" id="writing" style={{ backgroundColor: theme.secondary }}>
            <div className="container">
                <div className="writing--header">
                    <span className="eyebrow">Thought Leadership</span>
                    <h2 style={{ color: theme.primary }}>Writing &amp; technical analysis</h2>
                    <p style={{ color: theme.textSecondary }}>
                        Published perspectives on AI agents, fleet safety, and engineering at scale.
                    </p>
                </div>

                {/* Featured article */}
                <a
                    href={featured.url}
                    target="_blank"
                    rel="noreferrer"
                    className="writing--featured fade-in-up"
                    style={{ backgroundColor: theme.cardBg, borderColor: theme.border }}
                >
                    <div className="writing--featured-side">
                        <span className="writing--badge">Latest</span>
                        <span className="writing--source-large">{featured.source}</span>
                    </div>
                    <div className="writing--featured-body">
                        <div className="writing--meta">
                            <PenLine size={14} style={{ color: theme.accent }} />
                            <span style={{ color: theme.textSecondary }}>
                                {featured.topic} · {featured.date}
                            </span>
                        </div>
                        <h3 style={{ color: theme.primary }}>{featured.title}</h3>
                        <p style={{ color: theme.textSecondary }}>{featured.description}</p>
                        <span className="writing--read">
                            Read on {featured.source} <ArrowUpRight size={16} />
                        </span>
                    </div>
                </a>

                <div className="writing--grid">
                    {rest.map((post, index) => (
                        <a
                            key={post.id}
                            href={post.url}
                            target="_blank"
                            rel="noreferrer"
                            className="writing--card fade-in-up"
                            style={{
                                backgroundColor: theme.cardBg,
                                borderColor: theme.border,
                                animationDelay: `${index * 0.1}s`
                            }}
                        >
                            <div className="writing--content">
                                <div className="writing--meta">
                                    <BookOpen size={14} style={{ color: theme.accent }} />
                                    <span style={{ color: theme.textSecondary }}>
                                        {post.source} · {post.date}
                                    </span>
                                </div>
                                <h3 style={{ color: theme.primary }}>{post.title}</h3>
                                <p style={{ color: theme.textSecondary }}>{post.description}</p>
                                <span className="writing--read writing--read-sm">
                                    Read article <ArrowUpRight size={14} />
                                </span>
                            </div>
                        </a>
                    ))}
                </div>

                <div className="writing--cta">
                    <a href="https://medium.com/@raviteja.alchuri" target="_blank" rel="noreferrer" className="btn btn-secondary">
                        View all writing <ArrowUpRight size={16} />
                    </a>
                </div>
            </div>
        </section>
    );
}

export default Writing;
